import { connect } from 'react-redux';
import WhiteListedWithdrawAddressSelectComponent from './WhiteListedWithdrawAddressSelectComponent';
import {
  fetchAccountWithdrawInfos,
  selectWithdrawBank
} from 'apex-web/lib/redux/actions/eotcWithdrawActions';
import { change } from 'redux-form';
import { whiteListedAddressesSelector } from 'apex-web/lib/redux/selectors/depositWithdrawalSelectors';
import { openSidePane } from 'apex-web/lib/redux/actions/sidePaneActions';
import { SIDE_PANES } from 'apex-web/lib/constants/sidePanesConstants';
import { productPositionAssetsSelector } from 'apex-web/lib/redux/selectors/productPositionSelectors';

const mapStateToProps = state => {
  const {
    apexCore: { position }
  } = state;

  const withdrawAddresses = whiteListedAddressesSelector(state);
  const positionDetails = productPositionAssetsSelector(state).find(
    i => i.ProductId === position.selectedProductId
  );

  const options = [
    {
      value: 'default',
      label: 'Not selected'
    },
    ...withdrawAddresses.map(opt => ({
      value: opt.AccountIdentifier,
      label: `${opt.Name} - ${opt.AccountIdentifier}`,
      disabled: !opt.Verified
    }))
  ];

  return {
    positionDetails,
    isLoading: state.eotcWithdraw.isLoading,
    options,
    hasNoAddresses: withdrawAddresses.length === 0
  };
};

const mapDispatchToProps = dispatch => ({
  resetBankField: bank => dispatch(change('createFiatWithdraw', 'Bank', bank)),
  onSelect: bank => dispatch(selectWithdrawBank(bank)),
  fetchAccountWithdrawInfos: () => dispatch(fetchAccountWithdrawInfos()),
  openWhitelistSidepane: props =>
    dispatch(
      openSidePane(SIDE_PANES.WHITE_LIST_ADDRESS, {
        ...props,
        hideHeader: true
      })
    )
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WhiteListedWithdrawAddressSelectComponent);
